/*
	This is a simple text input and should be used only on
	simple cases, where validation is not required - e.g. forms.
	It has been created based on RIO UI Kit documentation.
*/
import type { LegacyRef } from 'react';

interface Props {
    id?: string;
    ref?: LegacyRef<HTMLInputElement>;
    label?: string;
    icon?: string;
    placeholder?: string;
    type?: string;
    inputClassName?: string;
    labelClassName?: string;
    iconClassName?: string;
    disabled?: boolean;
    name: string;
    value: string;
    onChange(e: string): void;
    onSelect?(): void;
    onBlur?(): void;
}

const TextInput = ({
    id,
    ref,
    label,
    icon,
    placeholder,
    type,
    inputClassName,
    labelClassName,
    iconClassName,
    disabled,
    name,
    value,
    onChange,
    onSelect,
    onBlur,
}: Props) => (
    <div className='form-group m-0'>
        {label && (
            <label htmlFor={name} className={labelClassName}>
                Input groups
            </label>
        )}
        <div className='input-group'>
            {icon && (
                <span className={`input-group-addon ${iconClassName}`}>
                    <span className={icon} />
                </span>
            )}
            <input
                id={id}
                ref={ref ?? null}
                autoComplete='off'
                name={name}
                value={value}
                disabled={disabled}
                type={type ?? 'text'}
                className={`form-control ${inputClassName}`}
                placeholder={placeholder}
                onChange={e => onChange(e.target.value)}
                onSelect={onSelect}
                onBlur={onBlur}
            />
        </div>
    </div>
);

export default TextInput;
